import type { PublisherDetail } from '../stores/publishersPageStore';

export const publisherExportFields = [
  { key: 'id', label: 'ID', value: (publisher) => publisher.id },
  { key: 'type', label: 'Type', value: (publisher) => publisher.type },
  { key: 'name', label: 'Name', value: (publisher) => publisher.name },
  {
    key: 'website',
    label: 'Website',
    value: (publisher) => publisher.website,
  },
  {
    key: 'address',
    label: 'Address',
    value: (publisher) => publisher.address,
  },
  {
    key: 'avatarUrl',
    label: 'Avatar URL',
    value: (publisher) => publisher.avatarUrl,
  },
  {
    key: 'avatarThumbnailUrl',
    label: 'Avatar thumbnail URL',
    value: (publisher) => publisher.avatarThumbnailUrl,
  },
  {
    key: 'walletAddress',
    label: 'Wallet address',
    value: (publisher) => publisher.walletAddress,
  },
  {
    key: 'nftMintAddress',
    label: 'NFT mint address',
    value: (publisher) => publisher.nftMintAddress,
  },
  {
    key: 'kybStatus',
    label: 'KYB status',
    value: (publisher) => publisher.kybStatus,
  },
  {
    key: 'isOwner',
    label: 'Owner',
    value: (publisher) => publisher.isOwner,
  },
  {
    key: 'isFrozen',
    label: 'Frozen',
    value: (publisher) => publisher.isFrozen,
  },
  {
    key: 'kycKybBypassEnabled',
    label: 'KYC/KYB bypass',
    value: (publisher) => publisher.kycKybBypassEnabled,
  },
  {
    key: 'memberCount',
    label: 'Members',
    value: (publisher) => publisher.memberCount,
  },
  {
    key: 'dappCount',
    label: 'Dapps',
    value: (publisher) => publisher.dappCount,
  },
  {
    key: 'publishedDappCount',
    label: 'Published dapps',
    value: (publisher) => publisher.publishedDappCount,
  },
  {
    key: 'userId',
    label: 'User ID',
    value: (publisher) => publisher.user.id,
  },
  {
    key: 'userEmail',
    label: 'User email',
    value: (publisher) => publisher.user.email,
  },
  {
    key: 'userFullName',
    label: 'User full name',
    value: (publisher) => publisher.user.fullName,
  },
  {
    key: 'userRole',
    label: 'User role',
    value: (publisher) => publisher.user.role,
  },
  {
    key: 'organizationId',
    label: 'Organization ID',
    value: (publisher) => publisher.organizationId,
  },
  {
    key: 'individualId',
    label: 'Individual ID',
    value: (publisher) => publisher.individualId,
  },
  {
    key: 'createdAt',
    label: 'Created at',
    value: (publisher) => formatTimestamp(publisher.created),
  },
  {
    key: 'updatedAt',
    label: 'Updated at',
    value: (publisher) => formatTimestamp(publisher.updated),
  },
] as const satisfies readonly {
  key: string;
  label: string;
  value: (publisher: PublisherDetail) => string | number | boolean | null;
}[];

export type PublisherExportFieldKey =
  (typeof publisherExportFields)[number]['key'];

export const defaultPublisherExportFieldKeys = [
  'id',
  'name',
  'website',
  'kybStatus',
] as const satisfies readonly PublisherExportFieldKey[];

function formatTimestamp(value: number | null) {
  return value === null ? '' : new Date(value).toISOString();
}

function csvCell(value: string | number | boolean | null) {
  const text = value === null ? '' : String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function buildPublisherCsv(
  publishers: PublisherDetail[],
  fieldKeys: PublisherExportFieldKey[],
) {
  const selectedFields = publisherExportFields.filter((field) =>
    fieldKeys.includes(field.key),
  );

  return [
    selectedFields.map((field) => field.key).join(','),
    ...publishers.map((publisher) =>
      selectedFields.map((field) => csvCell(field.value(publisher))).join(','),
    ),
  ].join('\n');
}
